export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS"
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR"
export const NEW_PASSWORD = "NEW_PASSWORD"
export const NEW_PASSWORD_SUCCESS = "NEW_PASSWORD_SUCCESS"
export const NEW_PASSWORD_ERROR = "NEW_PASSWORD_API_ERROR"
export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS"
export const UPDATE_PASSWORD_ERROR = "UPDATE_PASSWORD_ERROR"

//Reset Error
export const RESET_UPDATE_PASSWORD_ERROR = "RESET_UPDATE_PASSWORD_ERROR"
